<div class="info-pane">
  <h1>Haunted Harvest</h1>
  <div>
    <h3>What does that mean?</h3>
    <h3>
      It means dress as your <span
        style="background: #387002; color: #fff;">favorite veggie!</span
      >
    </h3>
    <h3>...but also make it spooky &#128123;</h3>
  </div>
  <div style="background: black; color: #ff8f00; padding: 1em 2em">
    <h2>Saturday, 10/23</h2>
    <h2>&#x1f383; at 7, &#128131; at 8:30</h2>
    <h2>Emerson</h2>
  </div>
</div>

<style>
  h1 {
    font-size: 80px;
  }
  h2 {
    font-size: 40px;
  }
  .info-pane {
    width: 100vw;
    height: 100vh;
    max-height: 100vh;
    background: #ff8f00;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    text-align: center;
  }
</style>
